<!-- Full screen bubble -->
<div class="announcement-overlay" *ngIf="fullscreenBubble">
  <div class="announcement-card" [ngStyle]="colorStyle(fullscreenBubble)">
    <span class="announcement-close" (click)="onClose(fullscreenBubble)">×</span>
    <img *ngIf="fullscreenBubble.imageUrl" class="announcement-image" [src]="fullscreenBubble.imageUrl">
    <h3 *ngIf="title(fullscreenBubble)" [dir]="titleDir(fullscreenBubble)" [ngStyle]="textColorStyle(fullscreenBubble)">{{ title(fullscreenBubble) }}</h3>
    <div class="announcement-body" [dir]="bodyDir(fullscreenBubble)" [innerHTML]="body(fullscreenBubble)"></div>
    <div class="announcement-actions">
      <button *ngIf="ctaText(fullscreenBubble)" class="announcement-cta" (click)="onCta(fullscreenBubble)">
        {{ ctaText(fullscreenBubble) }}
      </button>
      <a *ngIf="fullscreenBubble.allowDontShowAgain" class="announcement-dont-show" (click)="onDontShowAgain(fullscreenBubble)">
        {{ dontShowAgainText(fullscreenBubble) }}
      </a>
    </div>
  </div>
</div>

<!-- Corner bubbles — each bubble picks its own corner in UMT, so there's one
     fixed-position stack per corner, all reusing the same card template. -->
<div class="announcement-corner-stack announcement-corner-stack--bottom-right">
  <ng-container *ngFor="let b of bubblesAt('bottom-right')" [ngTemplateOutlet]="cornerCard" [ngTemplateOutletContext]="{ b: b }"></ng-container>
</div>
<div class="announcement-corner-stack announcement-corner-stack--top-right">
  <ng-container *ngFor="let b of bubblesAt('top-right')" [ngTemplateOutlet]="cornerCard" [ngTemplateOutletContext]="{ b: b }"></ng-container>
</div>
<div class="announcement-corner-stack announcement-corner-stack--bottom-left">
  <ng-container *ngFor="let b of bubblesAt('bottom-left')" [ngTemplateOutlet]="cornerCard" [ngTemplateOutletContext]="{ b: b }"></ng-container>
</div>
<div class="announcement-corner-stack announcement-corner-stack--top-left">
  <ng-container *ngFor="let b of bubblesAt('top-left')" [ngTemplateOutlet]="cornerCard" [ngTemplateOutletContext]="{ b: b }"></ng-container>
</div>

<ng-template #cornerCard let-b="b">
  <div class="announcement-corner-card" [ngStyle]="cornerCardStyle(b)">
    <span class="announcement-close" (click)="onClose(b)">×</span>
    <img *ngIf="b.imageUrl" class="announcement-corner-image" [src]="b.imageUrl">
    <h4 *ngIf="title(b)" [dir]="titleDir(b)" [ngStyle]="textColorStyle(b)">{{ title(b) }}</h4>
    <div class="announcement-body" [dir]="bodyDir(b)" [innerHTML]="body(b)"></div>
    <div class="announcement-actions">
      <button *ngIf="ctaText(b)" class="announcement-cta" (click)="onCta(b)">{{ ctaText(b) }}</button>
      <a *ngIf="b.allowDontShowAgain" class="announcement-dont-show" (click)="onDontShowAgain(b)">
        {{ dontShowAgainText(b) }}
      </a>
    </div>
  </div>
</ng-template>
